import type { ElementRef, FC, PropsWithChildren, RefObject } from 'react'
import { createContext, useContext } from 'react'

import { assert } from '../../../guards'
import type { Nullable } from '../../../types'

type HeaderContext = RefObject<ElementRef<'header'>>

const HeaderContext = createContext<Nullable<HeaderContext>>(null)

type HeaderContextProviderProps = {
  header: HeaderContext
}

export const HeaderContextProvider: FC<PropsWithChildren<HeaderContextProviderProps>> = ({
  header,
  children,
}) => {
  return <HeaderContext.Provider value={header}>{children}</HeaderContext.Provider>
}

export const useHeaderContext = (): HeaderContext => {
  const context = useContext(HeaderContext)

  assert(context !== null, 'Trying to use HeaderContext out of Header component')

  return context
}
